import {Map} from 'immutable';
import UAP from 'ua-parser-js';

export function hasTableProduct(table) {
    return !!table.get('open') && !!table.get('products') && table.get('products').size > 0;
}

export function hasTablesProduct(tables) {
    let hasProduct = false;
    tables.filter(t => !!t.get('open')).forEach(t => {
        if (!!t.get('products') && t.get('products').size > 0) {
            hasProduct = true;
        }
    });
    return hasProduct;
}

export function getUserAgent() {
    if (typeof navigator === 'undefined') {
        return '';
    }

    const nav = UAP(navigator); // eslint-disable-line no-undef
    return nav.ua;
}

export function validateBrowser() {
    if (typeof navigator === 'undefined') {
        return true;
    } else {
        // test here: http://faisalman.github.io/ua-parser-js/
        const nav = UAP(navigator); // eslint-disable-line no-undef
        let browserTitle = nav.browser.name.toLowerCase(); // eslint-disable-line no-undef
        const browserVersion = Number(nav.browser.major); // eslint-disable-line no-undef

        if (!browserTitle || !browserVersion) {
            return false;
        }

        if (['chrome', 'chromium', 'chrome webview'].indexOf(browserTitle) > -1 && browserVersion >= 55) {
            // browsers: chrome, chromium, app: android
            return true;
        } else if (browserTitle === 'firefox' && browserVersion >= 50) {
            // browser: firefox
            return true;
        } else if (browserTitle === 'safari' && browserVersion >= 10) {
            // browser: safari
            return true;
        } else if (browserTitle === 'mobile safari' && nav.os.name === 'iOS' && nav.device.model === 'iPad' && browserVersion >= 9) {
            // browser: safari on ipad
            return true;
        } else if (browserTitle === 'webkit' && nav.os.name === 'iOS' && nav.device.model === 'iPad' && nav.os.version >= 11) {
            // app: ipad
            return true;
        } else if (browserTitle === 'android browser' && browserVersion >= 4) {
            const osName = nav.os.name.toLowerCase(); // eslint-disable-line no-undef
            const osVersion = nav.os.version.split('.'); // eslint-disable-line no-undef
            let osVer = osVersion[0];
            if (1 in osVersion) {
                osVer += '.' +  osVersion[2];
            }
            if (osName === 'android' && Number(osVer) >= 5.1) {
                return true;
            }
        }

        return false;
    }
}

export function countDiscountPriceWithoutRound(totalPrice, discount) {
    return totalPrice - ((totalPrice / 100) * betterRound(discount, 2));
}

export function countDiscountPrice(totalPrice, discount) {
    return Math.round(betterRound(totalPrice - ((totalPrice / 100) * betterRound(discount, 2)), 2));
}

/**
 *
 * @param vats
 * @param items
 */
export function countVatsItesPrices(vats, items) {
    return vats.map(vat =>
        vat.set('sum', items
            .filter(item => item.get('vatId') === vat.get('id'))
            .reduce((sum, item) => sum + countDiscountPriceWithoutRound(item.get('price') * item.get('pcs'), item.get('discount')), 0)));
}

/**
 * takes a string in kebab case (words-divided-by-dashes) and returns it in CamelCase
 * @param string in kebab-case to transform
 * @returns original string in camelCase
 */
export function dashedToCamelCase(origString) {
    return origString.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
}

export function prepareKitchenOrder(number, items, tableName) {
    return Map({
        number: number,
        items: items,
        tableName: !!tableName ? tableName : null
    });
}

export function mapVat(vat) {
    return Map({
        id: vat.id,
        vat: vat.value,
        sum: 0
    });
}

export function prepareOrderObject(sellerId, items, totalPriceVat, totalPrices, billNum, bar, cashbox, takeaway,
                                   discount, branch, paymentType, sellTime, pkp, bkp, storno, note,
                                   fik = null, canDelete = true, device = null, canceled = false) {
    return Map({
        selectedProducts: items,
        totalPriceVat: totalPriceVat,
        totalPrices: totalPrices,
        time: sellTime,
        number: billNum,
        eet: Map({
            pkp: pkp,
            bkp: bkp,
            fik: fik
        }),
        bar: bar,
        cashbox: cashbox,
        takeaway: takeaway,
        discount: discount,
        branch: branch,
        paymentType: paymentType,
        storno: storno,
        canceled: canceled,
        note: note,
        canDelete: canDelete,
        device: device,
        sellerId: sellerId,
        kitchenNumber: null
    });
}

export function manageItemsToReceipt(items) {
    return items.map(item => {
        return Map({
            id: item.get('id'),
            discount: item.get('discount'),
            pcs: item.get('pcs'),
            name: item.get('name'),
            price: item.get('price'),
            vatId: item.get('vatId'),
            kitchen: item.get('kitchen'),
            addTime: new Date().getTime()
        })
    });
}

export function manageReceipt(receipt, vats, vatsMap) {
    const items = manageItemsToReceipt(receipt.get('selectedProducts'));
    return prepareOrderObject(
        receipt.get('sellerId'),
        items, //items,
        countTotalItemsPrice(items), //totalPriceVat,
        !!vatsMap ? vatsMap : countVatsItesPrices(vats, items), //totalPrices,
        receipt.get('number'), //billNum,
        receipt.get('bar'), //bar,
        receipt.get('cashbox'), //cashbox,
        receipt.get('takeaway'), //takeaway,
        receipt.get('discount'), //discount,
        receipt.get('branch'), //branch,
        receipt.get('paymentType'), //paymentType,
        receipt.get('time'), //sellTime,
        receipt.get('pkp'), //pkp,
        receipt.get('bkp'), //bkp,
        receipt.get('storno'), //storno,
        receipt.get('note'), //note
        receipt.get('fik'), //fik
        receipt.get('canDelete'), //canDelete
        receipt.get('device'), //canDelete,
        receipt.get('canceled'), //canceled
    );
}

export function betterRound(num, positions = 1) {
    if (isNaN(num)) {
        return num;
    } else {
        const pow = Math.pow(10, positions);
        return Math.round(num * pow + Number.EPSILON) / pow;
    }
}

export function manageReceipts(receipts, vats) {
    return receipts.map(receipt => {
        return manageReceipt(receipt, vats);
    });
}

export function countTotalItemsPrice(items) {
    return items.reduce((sum, item) => sum + (item.get('price') * item.get('pcs')), 0);
}

export function prepareOrdersToRequest(orders) {
    return orders.toSet().map(order => {
        return {
            selectedProducts: prepareRegisterItemsToRequest(order.get('selectedProducts'), order.get('discount')),
            time: order.get('time'),
            number: order.get('number'),
            bar: order.get('bar'),
            cashbox: order.get('cashbox'),
            takeaway: order.get('takeaway'),
            discount: order.get('discount'),
            branch: order.get('branch'),
            sellerId: order.get('sellerId'),
            paymentType: order.get('paymentType'),
            note: !!order.get('note') ? order.get('note') : ''
        };
    }).toJS();
}

export function prepareRegisterItemsToRequest(items, discount) {
    return items.toSet().map(item => {
        const discount = item.get('discount') === null || typeof item.get('discount') === 'undefined'
            ? discount === null || typeof discount === 'undefined'
                ? 0
                : discount
            : item.get('discount');
        return {
            id: item.get('id'),
            quantity: item.get('pcs'),
            discount: discount
        };
    }).toJS();
}

export function findFirstElementByClassInElement(element, classSelector) {
    if (typeof element === 'undefined') return null;
    const elements = element.getElementsByClassName(classSelector);
    if (elements === null || typeof elements === 'undefined') {
        return null;
    }
    if (elements.length === 0) {
        return null;
    }
    return elements[0];
}

export function findFirstElementByClass(classSelector) {
    if (typeof document === 'undefined') return null;
    const elements = document.getElementsByClassName(classSelector);
    if (elements === null || typeof elements === 'undefined') {
        return null;
    }
    if (elements.length === 0) {
        return null;
    }
    return elements[0];
}

export function findParentByClass(element, classSelector) {
    while ((element = element.parentElement) && !element.classList.contains(classSelector));
    return element;
}

export function getPriceOfMenuItem(prices, organizationCurrency, vat, vatList) {
    if (prices.size === 0) return 0;

    const price = prices.has(organizationCurrency) ? prices.get(organizationCurrency) : prices.first();
    let amount = price.get('amount');
    if (vat) amount = amount - amount / 100 * vatList.get(vat.toString()).get('value');
    amount = parseFloat(Math.round(amount * 100) / 100).toFixed(2);
    return {amount: amount, currency: price.get('currency')};
}

export function isOverflowedClass(elementClass) {
    if (typeof document === 'undefined') return false;
    const element = document.getElementsByClassName(elementClass)[0];
    if (element === null || typeof element === 'undefined') {
        return false;
    }
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

export function isOverflowedId(elementId) {
    if (typeof document === 'undefined') return false;
    const element = document.getElementById(elementId);
    if (element === null || typeof element === 'undefined') {
        return false;
    }
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

export function focusFirstInput(selector, delay = 0) {
    if (typeof document === 'undefined') throw new Error('This method can only be run in a browser environment');
    const input = document.querySelector(selector);   // eslint-disable-line no-undef
    if (!input) throw new Error(`Input with selector '${selector}' could not be found`);
    if (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA' || input.tagName === 'SELECT') {
        setTimeout(() => input.focus(), delay);
    } else {
        throw new Error('Selected element is not an input field');
    }
}

export function isClient() {
    return typeof window !== 'undefined';
}

export function getNameByLang(data) {
    if (!data) {
        return '';
    }
    if (!!data.getIn(['names', 'CS', 'name'])) {
        return data.getIn(['names', 'CS', 'name']);
    } else {
        return data.getIn(['names', 'EN', 'name']);
    }
}

export function prepareKitchenPrintArray(barName, kitchenToPrint, printSeparate, msg) {
    let printArray = [];

    if (!kitchenToPrint) {
        return null;
    }

    printArray.push(['title', `${msg.print.order}: ${kitchenToPrint.get('number')}`, 'ct']);
    printArray.push([]);
    printArray.push(['title', `${msg.print.bar}: ${barName}`, 'ct']);
    printArray.push([]);

    if (!!kitchenToPrint.get('tableName')) {
        printArray.push(['title', `${msg.print.bill}: ${kitchenToPrint.get('tableName')}`, 'ct']);
        printArray.push([]);
    }

    const date = new Date();
    printArray.push(['text', `${date.toLocaleString()}`, 'ct']);

    printArray.push([]);
    printArray.push([]);

    printArray.push(['-']);
    {!!kitchenToPrint.get('items') && kitchenToPrint.get('items').forEach(item => {
        if(printSeparate) {
            for(var i = 0; i < item.get('pcs'); i++) {
                printArray.push([`1x ${item.get('name')}`])
            }
        } else {
            printArray.push([`${item.get('pcs')}x ${item.get('name')}`]);
        }
    })}
    printArray.push(['-']);

    printArray.push([]);
    printArray.push([]);

    return printArray;
}

export function preparePrintArray(bar, organization, orderToPrint, branch, cashboxes, tableToPrint, printDailySum,
                                  dailySum, deviceId, msg, isInformative = false) {
    let printArray = [];

    if (!organization || !bar) {
        return null;
    }

    let toPrint = orderToPrint;
    if (!!printDailySum) {
        toPrint = dailySum;
    } else if (!!tableToPrint) {
        toPrint = tableToPrint;
    }

    if (toPrint === null || !toPrint || typeof toPrint === 'undefined') {
        return null;
    }

    let fiscalize = false;
    if (organization.get('fiscalize')) {
        fiscalize = !!cashboxes && cashboxes.getIn([toPrint.get('cashbox'), 'fiscalize']);
    }

    const itemsToPrint = !!toPrint.get('items') ? toPrint.get('items') : toPrint.get('selectedProducts');
    const discount = !!toPrint.get('discount') ? toPrint.get('discount') : 0;
    const totalPricePreRound = !!toPrint.get('totalPriceVat')
        ? toPrint.get('totalPriceVat')
        : !!itemsToPrint
            ? countTotalItemsPrice(itemsToPrint)
            : 0;
    const totalPriceRound = Math.round(totalPricePreRound);
    const discountPrice = countDiscountPrice(totalPriceRound, discount);
    const totalPrices = toPrint.get('totalPrices');

    printArray.push(['title', branch.get('name'), 'ct']);

    if (!!toPrint.get('storno')) {
        printArray.push(['title', msg.print.storno, 'ct']);
    }
    if (!!toPrint.get('note')) {
        printArray.push(['title', `${msg.print.bill}: ${toPrint.get('note')}`, 'ct']);
    }
    if (!!tableToPrint) {
        printArray.push(['title', `${msg.print.bill}: ${tableToPrint.get('name')}`, 'ct']);
    }
    if (!!toPrint.get('title')) {
        printArray.push(['title', `${msg.print.debtList}: ${toPrint.get('title')}`, 'ct']);
    }
    if (!!printDailySum) {
        const date = new Date();
        printArray.push(['title', `${date.toLocaleString()}`, 'ct']);
    }

    if(!isInformative) {
        let cashboxName = !!cashboxes && cashboxes.getIn([toPrint.get('cashbox'), 'name']);
        printArray.push(['text', `${organization.get('name')}, ${bar.get('name')}${!!cashboxName ? ', ' + cashboxName : ''}`, 'ct']);
        printArray.push(['text', `${msg.print.idNumber} ${organization.get('regnr')}, ${msg.print.vatId} ${organization.get('vatId')}`, 'ct']);
        printArray.push(['text', organization.getIn(['address', 'name']), 'ct']);
    }

    if (!!toPrint.get('kitchenNumber')) {
        printArray.push([]);
        printArray.push(['title', `${msg.print.orderNum}: ${toPrint.get('kitchenNumber')}`, 'ct']);
        printArray.push([]);
    }

    if (!!itemsToPrint && itemsToPrint.size === 0 && !!printDailySum) {
        printArray.push(['text', msg.print.reportNotOpen, 'ct']);
    }
    if (!!itemsToPrint) {
        printArray.push(['-']);
        if(isInformative) {
            printArray.push(['blackline']);
            printArray.push(['text', msg.print.notReceipt, 'ct']);
            printArray.push(['blackline']);
        }
        itemsToPrint.forEach(item => {
            let itemName = `${item.get('name')} (${(item.get('price')).toFixed(2)})`;
            if (!!item.get('discount')) {
                itemName += ` -${betterRound(item.get('discount'), 0)}%`;
            }
            let thirdColumn = '';
            if (typeof item.get('pcs') !== 'undefined') {
                thirdColumn = `${countDiscountPriceWithoutRound((item.get('price') * item.get('pcs')), item.get('discount')).toFixed(0)}`;
            }
            printArray.push([`${item.get('pcs')}x`, itemName, thirdColumn]);
        });
        printArray.push(['-']);
    }

    if (typeof totalPricePreRound !== 'undefined' && totalPricePreRound !== null) {
        if (toPrint.get('discount') > 0) {
            printArray.push(['text', `${msg.print.discount} ${betterRound(discount, 0)}% CZK ${Math.round(totalPriceRound - discountPrice)}`, 'rt']);
        }
        printArray.push(['title', `CZK ${Math.round(discountPrice).toFixed(0)}`, 'rt']);
    }
    if (!!organization.get('vatPayer') && !!totalPrices) {
        totalPrices.filter(vat => vat.get('sum') > 0).forEach(vat => {
            printArray.push(['text', `${msg.print.vat} ${vat.get('vat')}% CZK ${(vat.get('sum') - (vat.get('sum') / (1 + vat.get('vat') / 100.0))).toFixed(2)}`, 'rt']);
        });
    }
    if (!organization.get('vatPayer')) {
        printArray.push(['text', msg.print.noVat, 'ct']);
    }
    if (!!printDailySum) {
        printArray.push([]);
        toPrint.get('cashboxesSums').forEach(cashbox => {
            printArray.push([`${cashbox.get(0)}:`, `${cashbox.get(1).toFixed(2)} CZK`]);
        });
        printArray.push([]);
        printArray.push([`${msg.print.difference}:`, `${(toPrint.getIn(['report', 'salePriceMagic', 'CZK'])).toFixed(2)} CZK`]);
        printArray.push([`${msg.print.turnover}:`, `${(toPrint.getIn(['report', 'cashboxesPriceMagic', 'CZK'])).toFixed(2)} CZK`]);
        printArray.push([`${msg.print.difference}:`, `${(toPrint.getIn(['report', 'diferencePriceMagic', 'CZK'])).toFixed(2)} CZK`]);
        printArray.push([]);
        printArray.push([`${msg.print.sales}:`, `${(toPrint.getIn(['report', 'revenuePriceMagic', 'CZK'])).toFixed(2)} CZK`]);
    }
    if (!!tableToPrint) {
        const date = new Date();
        printArray.push(['text', `${msg.print.tableToDate} ${date.toLocaleString()}`, 'ct']);
    }
    if (!tableToPrint && !printDailySum) {
        if (!!toPrint.get('time')) {
            const time = typeof toPrint.get('time') === 'number' ? new Date(toPrint.get('time')) : toPrint.get('time');
            printArray.push([`${time.toLocaleString()}, ${msg.print.documentId} ${deviceId}-${toPrint.get('number')}`]);
        } else if (typeof toPrint.get('number') != 'undefined') {
            printArray.push([`${msg.print.documentId} ${deviceId}-${toPrint.get('number')}`]);
        }
        let paymentText = '';
        if (!!cashboxes && !!cashboxes.getIn([toPrint.get('cashbox'), 'type'])) {
            paymentText = cashboxes.getIn([toPrint.get('cashbox'), 'type']) === 'CASH' ? msg.print.payInCash : msg.print.payByCard;
        }
        if (fiscalize) {
            if (toPrint.get('eet') !== null && !!toPrint.getIn(['eet', 'fik'])) {
                paymentText += `, ${msg.print.normalMode}`;
            } else {
                paymentText += `, ${msg.print.offlineMode}`;
            }
            if (!!branch && branch.get('eetBranchId')) {
                paymentText += `, ${msg.print.branch}: ${branch.get('eetBranchId')}`;
            }
        }
        printArray.push([paymentText]);
        if (fiscalize && !(toPrint.get('eet') !== null && !!toPrint.getIn(['eet', 'fik']))) {
            printArray.push([`${msg.print.onlineBill}: check.ocellot.eu/${deviceId}-${toPrint.get('number')}`])
        }
        if (fiscalize && toPrint.get('eet') !== null) {
            if (!toPrint.getIn(['eet', 'fik']) && !!toPrint.getIn(['eet', 'pkp'])) {
                printArray.push([`PKP: ${toPrint.getIn(['eet', 'pkp'])}`]);
            }
            if (!!toPrint.getIn(['eet', 'fik'])) {
                printArray.push([`FIK: ${toPrint.getIn(['eet', 'fik'])}`]);
            }
            if (!!toPrint.getIn(['eet', 'bkp'])) {
                printArray.push([`BKP: ${toPrint.getIn(['eet', 'bkp'])}`]);
            }
        }
    }

    printArray.push([]);
    printArray.push([]);
    if(!isInformative) {
        printArray.push(['text', msg.print.thankYou, 'ct']);
        printArray.push(['text', msg.print.soldAndPrint, 'ct']);
    }

    return printArray;
}

export function isNeedArrayPrint(printType) {
    return isEnv(['android_app', 'electron']) && ['escpos-serial', 'escpos-net', 'escpos-bt', 'escpos-usb', 'escpos-bt'].indexOf(printType) > -1
}

export function print(printType, printAddress, printArray, sp, printLength, isBill, isBillPrintAllowed) {
    if (isEnv(['android_app', 'electron'])) {
        if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.printEscpos === 'function') {
            if (printType === 'off') {
                return;
            }
            if (isBill && !isBillPrintAllowed) {
                return;
            }
            const printString = JSON.stringify(printArray);

            if (printType === 'escpos-usb') {
                window.parent.Ocellot.printEscpos(printString, 'usb', printLength)
            } else if (printType === 'escpos-serial') {
                window.parent.Ocellot.printEscpos(printString, `serial:${printAddress}`, printLength)
            } else if (printType === 'escpos-net') {
                window.parent.Ocellot.printEscpos(printString, `net:${printAddress}`, printLength)
            } else if (printType === 'escpos-bt') {
                window.parent.Ocellot.printEscpos(printString, `bt:${printAddress}`, printLength)
            } else if (printType === 'default-silent') {
                window.setTimeout(function () {
                    window.parent.Ocellot.silentPrint(document.getElementById('print-receipt').innerHTML.toString());
                }, 200);
            } else if (printType === 'default') {
                window.setTimeout(function () {
                    window.parent.Ocellot.print(document.getElementById('print-receipt').innerHTML.toString());
                }, 200);
            }
        } else {
            window.setTimeout(function () {
                if (sp) {
                    window.parent.ocellotSilentPrint(document.getElementById('print-receipt').innerHTML.toString());
                } else {
                    window.parent.ocellotPrint(document.getElementById('print-receipt').innerHTML.toString());
                }
            }, 200);
        }

    } else {
        window.setTimeout(function () {
            window.print();
        }, 200);
    }
}

export function containsKitchenItemsToPrint(items) {
    return getKitchenItemsToPrint(items).size;
}

export function getKitchenItemsToPrint(items) {
    return items.filter(item => !!item.get('kitchen'));
}

export function printToKitchenNew(printImmediately, kitchenPrintType, kitchenPrintAddress, printArray, kitchenPrintLength) {
    const timeout = !!printImmediately && printImmediately ? 400 : 3500;

    if (isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.printEscpos === 'function') {
        if (kitchenPrintType === 'off') {
            return;
        }

        const printString = JSON.stringify(printArray);

        window.setTimeout(function () {
            if (kitchenPrintType === 'escpos-usb') {
                window.parent.Ocellot.printEscpos(printString, 'usb', kitchenPrintLength)
            } else if (kitchenPrintType === 'escpos-serial') {
                window.parent.Ocellot.printEscpos(printString, `serial:${kitchenPrintAddress}`, kitchenPrintLength)
            } else if (kitchenPrintType === 'escpos-net') {
                window.parent.Ocellot.printEscpos(printString, `net:${kitchenPrintAddress}`, kitchenPrintLength)
            } else if (kitchenPrintType === 'escpos-bt') {
                window.parent.Ocellot.printEscpos(printString, `bt:${kitchenPrintAddress}`, kitchenPrintLength);
            } else if (kitchenPrintType === 'default-silent') {
                window.parent.Ocellot.silentPrint(document.getElementById('print-receipt-kitchen').innerHTML.toString());
            } else if (kitchenPrintType === 'default') {
                window.parent.Ocellot.print(document.getElementById('print-receipt-kitchen').innerHTML.toString());
            }
        }, timeout);
    }
}

export function printToKitchen(printImmediately) {
    const timeout = !!printImmediately && printImmediately ? 400 : 3500;

    if (isElectron()) {
        window.setTimeout(function () {
            const template = document.getElementById('print-receipt-kitchen').innerHTML.toString();
            window.parent.ocellotPrint(template);
        }, timeout);
    }
}

export function changeOrganization() {
    localStorage.removeItem('domain');
    const protocol = location.protocol;
    // If old url (domain-pos.oecllot.eu) was used, use the host stripped of domain
    const host = location.host.indexOf('-') > -1 && location.host.indexOf('ocellot.eu') > -1 ? location.host.split(/-/)[1] : location.host;
    location.href = `${protocol}//${host}/choose-domain/1`;
}

export function findGetParameter(parameterName) {
    if (typeof location === 'undefined') {
        return null;
    } else {
        let result = null;
        let tmp = [];
        location.search // eslint-disable-line no-undef
            .substr(1)
            .split('&')
            .forEach(function(item) {
                tmp = item.split('=');
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }
}
export function showPrintAddress(key) {
    return ['escpos-serial', 'escpos-net', 'escpos-bt'].indexOf(key) > -1;
}

export function isEnv(envs) {
    const androidApp = envs.indexOf('android_app') > -1 ? isAndroidApp() : false;
    const electron = envs.indexOf('electron') > -1 ? isElectron() : false;
    const webDesktop = envs.indexOf('web_desktop') > -1 ? isWebDesktop() : false;
    const webMobile = envs.indexOf('web_mobile') > -1 ? isWebMobile() : false;

    return androidApp || electron || webDesktop || webMobile;
}

export function isWebMobile() {
    const nav = getUAP();
    if (!nav) {
        return false;
    }

    const osName = nav.os.name.toLowerCase(); // eslint-disable-line no-undef
    return ['ios', 'android'].indexOf(osName) > -1;
}

export function isWebDesktop() {
    const nav = getUAP();
    if (!nav) {
        return false;
    }

    const osName = nav.os.name.toLowerCase(); // eslint-disable-line no-undef
    return ['mac os', 'windows', 'linux', 'debian', 'mint', 'fedora', 'ubuntu', 'slackware', 'gentoo', 'suse', 'centos', 'kubuntu'].indexOf(osName) > -1;
}

export function isAndroidApp() {
    if ( typeof window !== 'undefined' && typeof window.parent !== 'undefined' && typeof window.parent.Ocellot !== 'undefined'  && typeof window.parent.Ocellot.isAndroidApp !== 'undefined') {
        return window.parent.Ocellot.isAndroidApp();
    } else {
        return false;
    }
}

export function isElectron() {
    if (typeof window !== 'undefined' && typeof window.parent !== 'undefined' && typeof window.parent.ocellotIsElectron !== 'undefined') {
        return window.parent.ocellotIsElectron();
    } else if ( typeof window !== 'undefined' && typeof window.parent !== 'undefined' && typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.isElectron !== 'undefined') {
        return window.parent.Ocellot.isElectron();
    } else {
        return false;
    }
}

export function getRelease() {
    if (typeof window !== 'undefined' && typeof window.parent !== 'undefined' && typeof window.parent.Ocellot.getRelease !== 'undefined') {
        return window.parent.Ocellot.getRelease();
    }
    return null;
}

export function getVersion() {
    if (typeof window !== 'undefined' && typeof window.parent !== 'undefined' && typeof window.parent.Ocellot.getVersion !== 'undefined') {
        return window.parent.Ocellot.getVersion();
    }
    return null;
}

function getUAP() {
    if (typeof navigator === 'undefined') {
        return false;
    } else {
        return UAP(navigator); // eslint-disable-line no-undef
    }
}



// WEBPACK FOOTER //
// ./src/common/lib/util.js